import { Card as CardEl, FlexCol, Text, theme } from '@veeqo/ui';
import { useTranslation } from 'context/TranslationContext';
import { VeeqoInlineSubtitle } from '../../Subtitles/VeeqoInlineSubtitle';
import { Alert } from '../../Alert/Alert';
import { ContentStyle, ErrorType } from '../../../content';
import { Progress } from '../../Progress/Progress';

export const DefaultCard = ({
  error,
  ready,
  jobId,
  contentStyle,
}: {
  error?: ErrorType;
  ready?: boolean;
  jobId?: string;
  contentStyle: ContentStyle;
}) => {
  const { t } = useTranslation();
  return (
    <CardEl.Surface
      style={{
        margin: 'auto',
        width: '50%',
        borderRadius: theme.sizes.xs,
        height: '100%',
        maxWidth: '700px',
        minWidth: '500px',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: `${contentStyle === ContentStyle.SELLER_CENTRAL ? 'AEmb, ' : ''}${
          theme.fontFamily
        }`,
        padding: theme.sizes.md,
      }}
    >
      <FlexCol gap={6}>
        {((!error && contentStyle === ContentStyle.SELLER_CENTRAL) ||
          contentStyle === ContentStyle.VEEQO) && (
          <VeeqoInlineSubtitle contentStyle={contentStyle} />
        )}
        {!error && !ready && (
          <Progress contentStyle={contentStyle} loadingColor={theme.colors.secondary.blue.base} />
        )}
        {error && <Alert contentStyle={contentStyle} errorKey={error} jobId={jobId} />}
        {!error && ready && <Text variant="body">{t('redirect_text')}</Text>}
      </FlexCol>
    </CardEl.Surface>
  );
};
